import { render, staticRenderFns } from "./SubjectItem.vue?vue&type=template&id=2cc331ce"
import script from "./SubjectItem.vue?vue&type=script&lang=js"
export * from "./SubjectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports